import React, { useState } from "react";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import {useSelector} from "react-redux";

const usePayouts = () => {

    let navigate = useNavigate();

    const authState = useSelector((state) => state.authReducer);

    const actions = {
        add: false,
        edit: (id) => navigate(`/pagos/${id.toString().split(',')[1]}/editar-pago`),
        delete: false,
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 'in_transit':
                return <Chip size="small" color="secondary" label="Preparando"
                             variant="outlined"/>;
            case 'paid':
                return <Chip size="small" color="success" label="Pagado"
                             variant="outlined"/>;
        }
    };

    return {
        actions,
        renderStatusChip
    }
};

export default usePayouts;
